import { Argenta } from '@argenta-types/homebank';

import { getLanguageFromUrlParams } from '../libs/I18nLoader/I18nLoader.utils';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const setLanguage = (language: Argenta.HomeBank.Global.I18n.Language): void => undefined;

interface useLanguageInterface {
  language: Argenta.HomeBank.Global.I18n.Language;
  setLanguage: (language: Argenta.HomeBank.Global.I18n.Language) => void;
}

export const useLanguage = (): useLanguageInterface => {
  const language = getLanguageFromUrlParams(window.location.pathname);
  return { language, setLanguage };
};
